import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConnectivityService } from 'app/core/connectivity/connectivity.service';
import { UserStore } from 'app/modules/users/store/user.store';
import { UpdateService } from './shared/services/update.service';
import { isTutorRole } from './shared/utils/role-utils';
import { FuseConfigService } from '@fuse/services/config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private _userStore = inject(UserStore);
    private _updateService = inject(UpdateService);
    private _fuseConfigService = inject(FuseConfigService);
    private _connectivityService = inject(ConnectivityService);

    constructor() {
        this._connectivityService.arm();
        effect(() => {
            const user = this._userStore.user()!;
            let layout: string = 'dante';
            if (isTutorRole(user.role)) {
                layout = 'dante-tutor';
            }
            this._fuseConfigService.config = {
                layout
            };
        });
    }

    async ngOnInit(): Promise<void> {
        await this._updateService.init();
    }
}
